(function () {
  var MKP_NS = 'mkpColorSwatchMounted';

  function findSourceForMount(mountPoint, instanceId) {
    // 1) Buscar dentro de la misma card (clave para carruseles con clones)
    var card = mountPoint.closest('.card-product') || mountPoint.parentElement;
    if (card) {
      var scoped = card.querySelector('[data-mkp-color-swatch-source="' + instanceId + '"]');
      if (scoped) return scoped;
    }

    // 2) Fallback global (por si algún layout no respeta el wrapper)
    return document.querySelector('[data-mkp-color-swatch-source="' + instanceId + '"]');
  }

  function mountOne(mountPoint) {
    if (!mountPoint) return false;

    var instanceId = mountPoint.getAttribute('data-mkp-color-swatch-mount');
    if (!instanceId) return false;

    // Evitar doble montaje en el MISMO mount point
    if (mountPoint.dataset[MKP_NS] === '1') return true;

    var source = findSourceForMount(mountPoint, instanceId);
    if (!source) return false;

    // Si el source está en otro sitio del DOM por algún motivo, lo traemos aquí
    source.hidden = false;
    source.removeAttribute('hidden');
    mountPoint.appendChild(source);

    mountPoint.dataset[MKP_NS] = '1';
    return true;
  }

  function boot(root) {
    var scope = root || document;
    var mounts = scope.querySelectorAll('[data-mkp-color-swatch-mount]');
    if (!mounts.length) return;

    mounts.forEach(function (mp) {
      mountOne(mp);
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function observeDom() {
    // Re-boot cuando se inserten nodos (recomendaciones AJAX, carruseles, clones de Splide, etc.)
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;

          // Si el propio nodo es un mount o contiene mounts, boot ahí
          if (node.matches && node.matches('[data-mkp-color-swatch-mount]')) {
            boot(node.parentNode || node);
          } else if (node.querySelector && node.querySelector('[data-mkp-color-swatch-mount]')) {
            boot(node);
          }
        }
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });
  }

  ready(function () {
    boot(document);
    observeDom();

    // Shopify Theme Editor
    document.addEventListener('shopify:section:load', function (e) {
      boot(e.target || document);
    });
  });
})();
